import { Tooltip } from '@mantine/core'
import { IconHelpCircle } from '@tabler/icons-react'

/** A "?" whose explanation is read on hover or focus instead of standing as text (AD-252). */
export function HelpTip({ label }) {
  return (
    <Tooltip label={label} multiline w={252} withArrow events={{ hover: true, focus: true, touch: true }}>
      <span
        role="img"
        tabIndex={0}
        aria-label={label}
        style={{ display: 'inline-flex', marginLeft: 4, verticalAlign: 'middle', color: '#868e96', cursor: 'help' }}
      >
        <IconHelpCircle size={14} stroke={1.8} />
      </span>
    </Tooltip>
  )
}
